import React, { useEffect, useState } from "react";
import AdminSidebar from "../../components/AdminSidebar";
import "./admin.css";

export default function RejectedResidents() {
  const [rejected, setRejected] = useState([]);
  const [error, setError] = useState("");

  const API = process.env.REACT_APP_API_URL;

  const loadRejected = async () => {
    try {
      const res = await fetch(`${API}/api/admin/rejected`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (!res.ok) {
        setError("Failed to load rejected residents");
        return;
      }

      const data = await res.json();
      setRejected(data);
    } catch (err) {
      setError("Server error while loading rejected residents");
    }
  };

  useEffect(() => {
    loadRejected();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="admin-layout">
      <AdminSidebar />

      <div className="admin-content">
        <h1>Rejected Residents</h1>

        {error && <p className="admin-error">{error}</p>}

        <div className="admin-table">
          <div className="admin-header">
            <span>Name</span>
            <span>Email</span>
            <span>Unit</span>
            <span>Tower</span>
          </div>

          {rejected.map((u) => (
            <div className="admin-row" key={u.id}>
              <span>{u.name}</span>
              <span>{u.email}</span>
              <span>{u.unitNumber}</span>
              <span>{u.tower || "—"}</span>
            </div>
          ))}

          {rejected.length === 0 && !error && (
            <p className="admin-empty">No rejected residents</p>
          )}
        </div>
      </div>
    </div>
  );
}